import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ShareStep } from '@app/main/cablepro/models/section.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-share-report-dialog',
  templateUrl: './share-report-dialog.component.html',
  styleUrls: ['./share-report-dialog.component.css']
})
export class ShareReportDialogComponent {

  ShareStep = ShareStep;

  @Input() calculationId!: number;
  @Input() reportType!: string;
  @Input() generatedLink!: string;

  @Output() shareCompleted = new EventEmitter<any>();
  shareStep: ShareStep = ShareStep.GetLink;
  showLoader = false;
  isLinkMessage = false;
  isCopy: boolean = true
  email = '';
  message = '';
  sendCopyToMe = false;

  constructor(public modal: NgbActiveModal) { }

  ngOnInit() {
    this.isLinkMessage = false;
    navigator.clipboard.readText().then(text => {
      if (this.generatedLink === text) {
        this.isLinkMessage = true;
      }
    });
  }

  startGenerateLink() {
    // this.shareStep = ShareStep.GeneratingLink;
    this.showLoader = true;
    setTimeout(() => {
      this.showLoader = false;
      this.shareCompleted.emit({
        action: 'link',
        generatedLink: this.generatedLink
      });
    }, 1500);
  }

  goToEmailStep() {
    this.emailErrorRequired = false;
    this.emailErrorInvalid = false;
    this.shareStep = ShareStep.EmailLink;
  }

  back() {
    this.shareStep = ShareStep.GetLink;
  }

  emailErrorRequired = false;
  emailErrorInvalid = false;

  validateEmailList(): boolean {
    this.emailErrorRequired = false;
    this.emailErrorInvalid = false;
    if (!this.email || this.email.trim().length === 0) {
      this.emailErrorRequired = true;
      return false;
    }
    const emailPattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,13}\b$/i;
    const emailArray = this.email.split(',');
    for (let e of emailArray) {
      const trimmed = e.trim();
      if (trimmed.length > 0 && !emailPattern.test(trimmed)) {
        this.emailErrorInvalid = true;
        return false;
      }
    }
    return true;
  }

  sendEmail() {
    if (!this.validateEmailList()) {
      return;
    }

    this.showLoader = true;
    setTimeout(() => {
      this.showLoader = false;
      const emailData = {
        action: 'email',
        email: this.email,
        message: this.message,
        sendCopyToMe: this.sendCopyToMe
      };

      this.shareCompleted.emit(emailData);
      this.modal.close(emailData);

    }, 1200);
  }

  tooltipTitle: string = "Copy"
  resetTimer: any;
  ngAfterViewInit() {
    setTimeout(() => {
      ($('.input-tooltip-btn [data-toggle="tooltip"]') as any).tooltip();
    });
  }

  onHover() {
    $('.input-tooltip-btn [data-toggle="tooltip"]').attr('data-original-title', this.tooltipTitle);
    ($('.input-tooltip-btn [data-toggle="tooltip"]') as any).tooltip('show');
  }

  onLeave() {
    ($('.input-tooltip-btn [data-toggle="tooltip"]') as any).tooltip('hide');
    if (!this.isCopy) {
      this.resetToCopy();
    }
  }

  copyLink() {
    navigator.clipboard.writeText(this.generatedLink);

    this.isCopy = false;
    this.tooltipTitle = "Copied!";

    $('.input-tooltip-btn [data-toggle="tooltip"]').attr('data-original-title', this.tooltipTitle);
    ($('.input-tooltip-btn [data-toggle="tooltip"]') as any).tooltip('show');

    clearTimeout(this.resetTimer);
    this.resetTimer = setTimeout(() => {
      this.resetToCopy();
    }, 4000);
  }

  resetToCopy() {
    this.isCopy = true;
    this.tooltipTitle = "Copy";

    $('.input-tooltip-btn [data-toggle="tooltip"]').attr('data-original-title', this.tooltipTitle);
  }
  close() {
    this.onLeave();
    this.modal.close();
  }
}
